'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.authenticatedUser', [])

.factory('authenticatedUserService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/AuthenticatedUser';

    service.getAuthenticatedUser = function () {
        return $http.get(baseUrl, { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
